export const eeIncentiveTableDomestic = [
  { start: 1, end: 200, rebate: 25.0 },
  { start: 201, end: 250, rebate: 24.5 },
  { start: 251, end: 300, rebate: 22.5 },
  { start: 301, end: 350, rebate: 21.0 },
  { start: 351, end: 400, rebate: 17.0 },
  { start: 401, end: 450, rebate: 14.5 },
  { start: 451, end: 500, rebate: 12.0 },
  { start: 501, end: 550, rebate: 10.5 },
  { start: 551, end: 600, rebate: 9.0 },
  { start: 601, end: 650, rebate: 7.5 },
  { start: 651, end: 700, rebate: 5.5 },
  { start: 701, end: 750, rebate: 4.5 },
  { start: 751, end: 800, rebate: 4.0 },
  { start: 801, end: 850, rebate: 2.5 },
  { start: 851, end: 900, rebate: 1.0 },
  { start: 901, end: 1000, rebate: 0.5 },
];
